import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const categoryApi = createAsyncThunk('category', async () => {
    const response = await axiosInstance.get('/category/subCategory');
    return response.data;
});

const categorySlice = createSlice({
    name: "category",
    initialState: {
        data: [],
        errors: [],
        status: "idle"
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(categoryApi.pending, (state) => {
                state.status = "loading";
            })
            .addCase(categoryApi.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = "idle";
            })
            .addCase(categoryApi.rejected, (state, action) => {
                state.errors.push(action.error.message);
                state.status = "idle";
            });
    }
});

export default categorySlice.reducer;
